module.exports = __webpack_public_path__ + "img/img_rank_02.8633cca8.svg";